import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const MuiValidTextField = ({ field, form: { touched, errors }, styled, ...props }) => {
  const keys = field.name.split('.');
  const error = keys.reduce((obj, key) => obj?.[key], touched);
  const errorMessage = keys.reduce((obj, key) => obj?.[key], errors);
  return styled ? (
    <TextFieldStyled
      error={error && !!errorMessage}
      helperText={error && errorMessage}
      sx={{ width: '100%' }}
      {...field}
      {...props}
    />
  ) : (
    <TextField
      error={error && !!errorMessage}
      helperText={error && errorMessage}
      sx={{ width: '100%' }}
      {...field}
      {...props}
    />
  );
};

export default MuiValidTextField;

const TextFieldStyled = styled(TextField)({
  '& label.Mui-focused': {
    color: '#075985',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#075985',
  },
});
